import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  bookmarksByCourse: [],
  userActiveCourses: [],
  pendingBookmark: [],
  allProgress: [],
  progress: [],
  pathProgress: [],
  pathResume: [],
  activeSubscriptions: [],
  sampleAvatars: [],
  currentAvatar: '/assets/icons/avatars/avatar1.png',
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
